/**
 * Visibilité du panel autocomplete (criteria / tags).
 * Garde le dropdown ouvert après recherche terminée même à 0 résultat (`searchSettled`),
 * pour afficher le message « aucun résultat » au lieu de fermer immédiatement.
 */
export type U2000AutoCompleteDropdownVisibilityInput = {
  isFocused: boolean;
  disabled?: boolean;
  /** Query non vide (trim) et/ou seuil min atteint côté tags */
  queryReady: boolean;
  dropdownClosed?: boolean;
  loading: boolean;
  suggestionCount: number;
  /** True après une recherche terminée pour la saisie courante (y compris 0 hit). */
  searchSettled: boolean;
};

export function u2000ShouldShowAutoCompleteDropdown(
  input: U2000AutoCompleteDropdownVisibilityInput,
): boolean {
  const {
    isFocused,
    disabled = false,
    queryReady,
    dropdownClosed = false,
    loading,
    suggestionCount,
    searchSettled,
  } = input;
  if (!isFocused || disabled || !queryReady || dropdownClosed) {
    return false;
  }
  return loading || suggestionCount > 0 || searchSettled;
}
